export default __webpack_public_path__ + "static/media/banner_3.24ac6bcc.jpg";